angular.module('rental')
    .factory('RentalAgreementPaymentRegistry', function ($resource) {
        return $resource('/crm/api/rental-agreement/:id/payment-registry', {id: "@id"}, {})
    })
    .service('RentalAgreementPaymentRegistryService', function (modals, $rootScope, RentalAgreementConst, RentalAgreementPaymentRegistry) {
        this.edit = (id) => {
            return modals.open('app/rental/agreement/payment-registry-edit.html', 'RentalAgreementPaymentRegistryEditController', {id: id}, {size: "lg"}, "$ctrl")
        }
        this.delete = (id) => {
            return modals.confirmDelete("rejestr", () => RentalAgreementPaymentRegistry.delete({id: id}).$promise)
                .then(() => $rootScope.$broadcast(RentalAgreementConst.eventUpdate, id))
        }
    })
